module.exports = __webpack_public_path__ + "img/upload.57789b0c.svg";